if(window !== undefined && window.theme ) {

    window.theme.Cart = window.theme.Cart ? window.theme.Cart : {}

    async function GetCart() {
        try {
            const result = await fetch(`${routes.cart_url}`)
            if(result.ok) {
                const text = await result.text()
                TriggerEvent('PopulateCart', text)
            } else {
                // TODO ERROR Notification Settings
                console.log('Error:', error)
            }

        } catch (error) {
            console.log('Error:', error)
        }
    }
    theme.Cart.GetCart = GetCart;

    theme.Cart.cartUpdateUnsubscriber = undefined;

    theme.Cart.cartUpdateUnsubscriber = SubscribeToEvent('UpdateCart', (eventData) => {
        theme.Cart.GetCart()
    });
}
